import {
  getGroupShareLink,
  getProjectShareLinks,
  normalizeAvailableMessengers,
  deriveLegacyMessenger,
  resolveMessenger,
} from "./messengers";
import { mergeChatAccessGateIntoSettings } from "./chatAccessGate";

export { readChatAccessGateFromSettings, mergeChatAccessGateIntoSettings } from "./chatAccessGate";

export function getAccessMode() {
  return "group";
}

export function getAccessLabel() {
  return "Групповой";
}

export function getGroupShareLinkForContext(
  gameId,
  { userMessenger, gameMessenger, gameSettings } = {}
) {
  if (gameSettings) {
    const links = getProjectShareLinks(gameId, gameSettings);
    return links[0]?.link ?? "";
  }

  const messengerId = resolveMessenger({
    userMessenger,
    gameMessenger,
  });
  return getGroupShareLink(gameId, messengerId);
}

export function getProjectShareLinksForContext(gameId, gameSettings) {
  return getProjectShareLinks(gameId, gameSettings);
}

export {
  getGroupShareLink,
  getAccessModeHint,
  getAccessModeHintForMessengers,
  getMessengerChannelLabel,
  resolveMessenger,
  normalizeAvailableMessengers,
  deriveLegacyMessenger,
  getProjectShareLinks,
} from "./messengers";

export function getProjectStatusFromSettings(gameSettings) {
  if (gameSettings?.hidden) return "hidden";
  if (gameSettings?.published) return "published";
  return "draft";
}

export function mergeGameSettings(existingSettings = {}, patch = {}) {
  const merged = {
    private_access: patch.private_access ?? existingSettings.private_access ?? false,
    adult_content: Boolean(
      patch.adult_content ?? existingSettings.adult_content
    ),
    published: Boolean(patch.published ?? existingSettings.published),
    hidden: Boolean(patch.hidden ?? existingSettings.hidden),
    completion_text:
      patch.completion_text ?? existingSettings.completion_text ?? "",
    author_telegram:
      patch.author_telegram ?? existingSettings.author_telegram ?? "",
    allow_replay: patch.allow_replay ?? existingSettings.allow_replay ?? true,
    messenger:
      patch.messenger ??
      deriveLegacyMessenger(
        patch.availableMessengers ?? existingSettings.availableMessengers
      ) ??
      existingSettings.messenger,
    availableMessengers: normalizeAvailableMessengers({
      availableMessengers:
        patch.availableMessengers ?? existingSettings.availableMessengers,
      messenger: patch.messenger ?? existingSettings.messenger,
    }),
    contentType:
      patch.contentType ?? existingSettings.contentType,
  };

  return mergeChatAccessGateIntoSettings(merged, {
    requireChatMembership:
      patch.requireChatMembership ?? existingSettings.requireChatMembership,
    accessTelegramChatId:
      patch.accessTelegramChatId ?? existingSettings.accessTelegramChatId,
    accessTelegramChatTitle:
      patch.accessTelegramChatTitle ?? existingSettings.accessTelegramChatTitle,
    accessMaxChatId: patch.accessMaxChatId ?? existingSettings.accessMaxChatId,
    accessMaxChatTitle:
      patch.accessMaxChatTitle ?? existingSettings.accessMaxChatTitle,
  });
}

export function mergeGameSettingsWithGamification(existingSettings = {}, patch = {}) {
  const merged = mergeGameSettings(existingSettings, patch);
  if (patch.gamification == null) {
    return merged;
  }
  return {
    ...merged,
    gamification: {
      ...(existingSettings.gamification ?? {}),
      ...patch.gamification,
      monthlyChallenge: {
        ...(existingSettings.gamification?.monthlyChallenge ?? {}),
        ...(patch.gamification?.monthlyChallenge ?? {}),
      },
    },
  };
}

export function settingsFromProjectStatus(projectStatus, existingSettings = {}) {
  return mergeGameSettings(existingSettings, {
    published: projectStatus === "published",
    hidden: projectStatus === "hidden",
  });
}

export function getProjectStatusDisplay(settings) {
  if (settings?.hidden) {
    return { label: "Остановлен", tone: "stopped" };
  }
  if (settings?.published) {
    return { label: "Опубликован", tone: "published" };
  }
  return { label: "В работе", tone: "draft" };
}

export const ACCESS_MODE_HINT =
  "Сотрудники проходят сценарий по общей ссылке в выбранном мессенджере. Нужна активная бизнес-подписка по размеру команды.";

export const EXAMPLE_START_POST = {
  title: "Долг платежом красен",
  description:
    "Привет! Ты готов начать увлекательное приключение со мной?",
  posterSrc: `${process.env.PUBLIC_URL}/images/bg.png`,
};
